import { CustomField } from './custom-field';

export class ProjectInfo {
    apiKey: string;
    username: string; // celui affiché
    project: string; // le nom utilisé pour get la config propre projet
    language: string;
    customFields: CustomField[];

    constructor(
        apiKey: string,
        username: string,
        project: string,
        language: string,
        customFields: CustomField[]
    ) {
        this.apiKey = apiKey;
        this.username = username;
        this.project = project;
        this.language = language;
        this.customFields = customFields;
    }
}
